import { createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension'
import { createBrowserHistory } from 'history'
import * as Sentry from '@sentry/react'

import createRootReducer from './reducer'

const sentryReduxEnhancer = Sentry.createReduxEnhancer()

export const history = createBrowserHistory()

export default function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware()

  const store = createStore(
    createRootReducer(history), // root reducer with router state
    initialState,
    composeWithDevToolsDevelopmentOnly(
      applyMiddleware(routerMiddleware(history), thunk, sagaMiddleware),
      sentryReduxEnhancer,
    ),
  )

  return {
    ...store,
    runSaga: sagaMiddleware.run,
  }
}
